export const PROFILE_ENDPOINTS = {
  USER_PROFILE: '/api/users/profile',
  UPDATE_PROFILE: '/api/users/profile',
  ACCOUNT_STATUS: '/api/dashboard/profile/status',
  KYC_DETAILS: '/api/kyc/details',
  KYC_STATUS: '/api/kyc/status',
  KYC_RE_INITIATE: '/api/kyc/sessions/reinitiate',
} as const
